<template>
	<div class="page">
		<nav-bar :home="true" />
		<div class="bannerBox" v-if="banner?.length > 0">
			<van-swipe ref="banner" class="banner" :autoplay="5000" :show-indicators="false" @change="">
				<van-swipe-item v-for="(item, index) in banner" :key="index">
					<div class="item video" @click.stop="play(item, index)">
						<!-- <img src="@/assets/images/mask.png" class="mask" /> -->

						<img v-if="item?.type == 2" :src="item?.cover_path" class="cover" />

						<img v-if="item?.type == 1" src="@/assets/images/play.png" class="play" @click.stop="play(item, index)" />
						<img v-if="item?.type == 1" :src="item?.cover_path || `${item?.path?.url}?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto`" class="cover" />
					</div>
				</van-swipe-item>
			</van-swipe>
			<div class="option" v-if="banner?.length > 1">
				<img src="@/assets/images/arrow-left.png" class="left icon" @click.stop="prev" />
				<img src="@/assets/images/arrow-right.png" class="right icon" @click.stop="next" />
			</div>
		</div>

		<van-tabs class="tab" v-model="tabIndex" :animated="true" :swipeable="true" @change="tabChange">
			<van-tab title="点一点看展品">
				<van-skeleton title :row="8" :loading="loadingPage" style="margin-top: 30px">
					<div class="content" v-if="list?.length > 0">
						<ul class="list">
							<li class="item" v-for="(item, index) in list" :key="index" :class="{ open: item?.open }">
								<div class="head" @click.stop="open(item, index)">
									<span class="ellipsis1" v-text="item?.name || `暂无名称`"></span>
									<!-- <svg class="arrow" v-if="item?.info?.length > 3">
										<path
											fill-rule="evenodd"
											fill="#ffffff"
											d="M0.661,4.890 L4.746,0.972 C4.871,0.835 5.123,0.835 5.248,0.972 L9.333,4.890 C9.396,4.973 9.521,5.000 9.616,5.000 C9.961,5.000 10.118,4.644 9.898,4.425 L5.500,0.205 C5.217,-0.069 4.746,-0.069 4.494,0.205 L0.095,4.425 C-0.124,4.644 0.064,5.000 0.378,5.000 C0.504,5.000 0.598,4.973 0.661,4.890 L0.661,4.890 Z"
										/>
									</svg> -->

									<svg viewBox="0 0 1792 1024" class="arrow" v-if="item?.info?.length > 3">
										<path
											d="M1570.653045 38.095248L895.90705 713.865136 221.161055 37.967261A129.778535 129.778535 0 0 0 38.012056 221.500219l763.696767 764.720661c25.853318 25.981304 60.153759 38.396016 94.198227 37.756082 34.044468 0.639934 68.344909-11.774778 94.326213-37.756082l763.696767-764.720661a129.906522 129.906522 0 0 0 0-183.404971 129.394575 129.394575 0 0 0-183.276985 0z"
											fill="#ffffff"
										></path>
									</svg>
								</div>
								<div class="main">
									<div class="children" v-if="item?.info?.length > 0">
										<div
											class="childrenItem text_center"
											v-for="(child, childIndex) in item?.info"
											:key="childIndex"
											@click.stop="goDetails(child, childIndex, item, index)"
										>
											<div class="cover">
												<img v-if="child?.cover" :src="child?.cover" />
											</div>
											<div class="name ellipsis2" v-text="child?.title || `暂无名称`"></div>
										</div>
									</div>
									<van-empty class="emptyDiy" v-else description="暂无内容" image-size="60" />
								</div>
							</li>
						</ul>
					</div>
					<van-empty v-else description="暂无内容" />
				</van-skeleton>
			</van-tab>
			<van-tab title="逛一逛云看展">
				<van-skeleton title :row="8" :loading="loadingPage" style="margin-top: 30px">
					<!-- <div class="content" v-if="list2?.length > 0">
					<ul class="list">
						<li class="item" v-for="(item, index) in list2" :key="index">
							<div class="head" @click.stop="more(item, index)" v-monitor="`查看更多`">
								<b>
									<span v-text="item?.name || ``"></span>
								</b>
								<div class="more">
									<span>查看更多</span>
									<svg class="moreIcon">
										<path
											fill-rule="evenodd"
											fill="#ffffff"
											d="M0.661,4.890 L4.746,0.972 C4.871,0.835 5.123,0.835 5.248,0.972 L9.333,4.890 C9.396,4.973 9.521,5.000 9.616,5.000 C9.961,5.000 10.118,4.644 9.898,4.425 L5.500,0.205 C5.217,-0.069 4.746,-0.069 4.494,0.205 L0.095,4.425 C-0.124,4.644 0.064,5.000 0.378,5.000 C0.504,5.000 0.598,4.973 0.661,4.890 L0.661,4.890 Z"
										/>
									</svg>
								</div>
							</div>
							<div class="main_2">
								<van-swipe
									v-if="item?.info?.length > 0"
									ref="newList"
									class="newList"
									:autoplay="5000"
									:show-indicators="false"
									@change="new_change($event, item, index)"
								>
									<van-swipe-item class="newItem" v-for="(child, childIndex) in item?.info" :key="childIndex">
										<div class="border" @click="goWeb(child[0], index + 1)">
											<div class="cover">
												<img v-if="child[0]?.cover" :src="child[0]?.cover" />
											</div>
											<div class="name" v-text="child[0]?.title || `暂无名称`"></div>
											<div class="foot">
												<div class="time" v-text="getTime(child[0]?.created_at) || `暂无时间`"></div>
												<img src="@/assets/images/arrow.png" class="rightIcon" />
											</div>
										</div>
										<div class="border" @click="goWeb(child[1], index + 1)">
											<div class="cover">
												<img v-if="child[1]?.cover" :src="child[1]?.cover" />
											</div>
											<div class="name ellipsis1" v-text="child[1]?.title || `暂无名称`"></div>
											<div class="foot">
												<div class="time" v-text="getTime(child[1]?.created_at) || `暂无时间`"></div>
												<img src="@/assets/images/arrow.png" class="rightIcon" />
											</div>
										</div>
									</van-swipe-item>
								</van-swipe>
								<van-empty v-else description="暂无内容" />
								<div class="pagination" v-if="item?.info?.length > 0">
									<span v-for="(child, childIndex) in item?.info" :key="childIndex" :class="{ current: childIndex == item?.newCurrent }"></span>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<van-empty v-else description="暂无内容" /> -->

					<div class="main">
						<van-tabs v-if="monthKey" v-model="active" @change="monthChange">
							<van-tab v-for="(item, index) in month" :key="index" :title="`${item?.label}月`"></van-tab>
						</van-tabs>
						<div class="clear"></div>
						<van-list
							class="list"
							v-model="loading"
							:finished="finished"
							loading-text="加载更多"
							finished-text="没有更多了"
							:immediate-check="false"
							:offset="80"
							@load="onLoad"
							v-if="list2?.length > 0"
						>
							<li class="item" v-for="(item, index) in list2" :key="index" @click.stop="goWeb(item, index)">
								<div class="cover">
									<img v-if="item?.cover" :src="item?.cover" />
								</div>
								<div class="name ellipsis3" v-html="item?.title || `暂无名称`"></div>
								<div class="foot">
									<div class="left">
										<div class="time" v-text="item?.times || `暂无时间`"></div>
										<div class="address" v-text="item?.address || `暂无地点`"></div>
									</div>
									<img src="@/assets/images/arrow.png" class="rightIcon" />
								</div>
							</li>
						</van-list>
					</div>
					<van-empty v-if="list2?.length == 0" description="敬请期待" />
				</van-skeleton>
			</van-tab>
			<van-tab title="找圈子获信息">
				<div class="info">
					<h2 class="title">IT邦</h2>
					<div class="main">
						<div class="photo">
							<img src="@/assets/images/c1.jpg" />
						</div>
						<!-- <p>耐德电气集团的一个主要事业部-IT事业部，规模达到30亿美元（24亿欧元），成为全球关键电源及制冷服务行业第一。</p> -->
					</div>
					<h2 class="title">施耐德电气研修院</h2>
					<div class="main">
						<div class="photo">
							<img src="@/assets/images/c2.jpg" />
						</div>
						<p>
							若想了解更多内容，请
							<span @click.stop="goLink">点击前往</span>
							<b></b>
							施耐德电气研修院是施耐德电气倾力打造的一体化专业学习平台，上千门优质课程随时随地学习。学习、考试、获证，足不出户就能获得施耐德电气专业认证。丰富的课程，专业的体验，便捷的使用，轻松实现自我学习管理。
						</p>
					</div>
				</div>
			</van-tab>
		</van-tabs>

		<!--悬浮按钮-->
		<!-- <drag-view>
			<div class="float-button" v-monitor="`点击问卷`" @click.stop="survey">
				<img src="@/assets/images/edit.png" />
				<div>
					填问卷
					<p></p>
					得积分
				</div>
			</div>
		</drag-view> -->
		<float-btn :slotState="true">
			<div class="float-button">
				<div class="button" v-for="(item, index) in actions" :key="index" @click.stop="selectOption(item, index)" v-text="item?.name"></div>
			</div>
		</float-btn>

		<video
			v-if="welcome"
			src="https://schneider-wechat.oss-cn-beijing.aliyuncs.com/truck-minisite/202403/rc-upload-1711431253667-9.mp4"
			poster="https://schneider-wechat.oss-cn-beijing.aliyuncs.com/truck-minisite/202403/rc-upload-1711506916622-3.jpg"
			class="welcome"
			id="welcome"
			ref="welcome"
			:muted="false"
			:loop="false"
			:controls="true"
			:autoplay="false"
			:playsinline="true"
			@ended="videoEnded"
		></video>
		<svg v-if="welcome" t="1711362229289" class="closeWelcome" viewBox="0 0 1024 1024" version="1.1" @click.stop="videoEnded">
			<path
				d="M517.12 944.64c-236.11392 0-427.52-191.40608-427.52-427.52 0-236.11392 191.40608-427.52 427.52-427.52 236.11392 0 427.52 191.40608 427.52 427.52C944.64 753.23392 753.23392 944.64 517.12 944.64zM517.12 143.04256c-206.59712 0-374.08256 167.48544-374.08256 374.08256S310.52288 891.20256 517.12 891.20256c206.60224 0 374.08256-167.48544 374.08256-374.08256S723.72224 143.04256 517.12 143.04256zM555.06432 517.26848l113.2032 113.2032c10.42432 10.42944 10.42432 27.3664 0 37.79584-10.43456 10.42944-27.35104 10.42944-37.79584 0l-113.2032-113.20832-113.99168 113.9712c-10.51648 10.5216-27.5712 10.5216-38.07744 0-10.51648-10.5216-10.51648-27.5712 0-38.07744l113.98144-113.98144L365.97248 403.75296c-10.43456-10.42944-10.43456-27.35104 0-37.78048 10.43456-10.43968 27.34592-10.43968 37.79072 0l113.21344 113.20832 114.82112-114.82112c10.51648-10.5216 27.5712-10.5216 38.08256 0 10.51648 10.51136 10.51648 27.5712 0 38.08256L555.06432 517.26848z"
				fill="#ffffff"
			></path>
		</svg>
		<!-- <img v-if="welcome && welcomeKey" src="@/assets/images/play.png" class="welcome_play" @click.stop="videoPlay" /> -->
	</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FloatBtn from '@/components/FloatBtnH5.vue';
import DragView from '@/components/DragView.vue';
import { Swipe, SwipeItem, Skeleton, Toast, Empty } from 'vant';
import changeUrl from '@/utils/changeUrl';
export default {
	components: {
		NavBar,
		FloatBtn,
		DragView,
		Skeleton,
		[Swipe.name]: Swipe,
		[SwipeItem.name]: SwipeItem,
		[Empty.name]: Empty
	},
	data() {
		return {
			loadingPage: true,
			welcomeKey: false,
			welcome: false,
			clickType: false,
			banner: [],
			tabIndex: 0,
			list: [],
			/* list2: [
				{
					name: `大卡车`,
					newCurrent: 0,
					info: []
				},
				{
					name: `小卡车`,
					newCurrent: 0,
					info: []
				}
			], */
			active: 0,
			list2: [],
			current: 1,
			pageSize: 3,
			total: 0,
			loading: false,
			finished: false,
			tips: null,
			month: [],
			monthKey: true
		};
	},
	created() {
		let key = this.$localStorage.getItem('welcome');
		if (!key) {
			this.$localStorage.setItem('welcome', true);
			this.welcomeKey = true;
			this.welcome = true;
		}
	},
	mounted() {
		this.initShare();
		this.$dataStatistics({ event_type: 'view', page_title: '首页' }, ``);

		this.init();
	},
	methods: {
		async init() {
			if (this.$route.query?.tabIndex) {
				if (this.$route.query?.form == 'excelLink' && this.$route.query?.tabIndex == 2) {
					this.tabIndex = 0;
				} else {
					this.tabIndex = this.$route.query?.tabIndex * 1;
				}
			}

			// 获取最近的四个月，并将其转换为对象数组，每个对象包含一个 label 属性
			let month = this.getLastFourMonths();
			this.month = month?.map((item) => {
				return { label: item };
			});

			// 设置当前激活的月份为最后一个月份的索引，如果没有月份则为 0
			this.active = this.month?.length - 1 || 0;
			console.log(this.month);

			const indicesToRemove = [];

			// 遍历月份数组，检查每个月是否有数据，如果没有数据则从数组中删除
			await Promise.all(
				this.month.map(async (item, index) => {
					const ml = await this.getList2(true, true, item.label);
					if (ml?.length == 0) {
						// 使用 filter 方法生成一个新数组，避免在遍历过程中直接修改数组
						indicesToRemove.push(index);
					}
				})
			);

			this.month = this.month.filter((_, index) => !indicesToRemove.includes(index));

			// 重新设置当前激活的月份为最后一个月份的索引，如果没有月份则为 0
			this.active = this.month?.length - 1 || 0;
			console.log(this.month);

			this.$nextTick(() => {
				this.getBanner();
				this.getList();
				this.getList2(true, true);
			});
		},
		getBanner() {
			this.banner = [];
			this.$http.get(`/platform/video`, { params: { pageSize: 9999 } }).then((res) => {
				let list = res?.data?.data;
				this.banner = list;
			});
		},
		getList() {
			this.list = [];
			this.$http.get(`/platform/categorys`, { params: { pageSize: 9999 } }).then((res) => {
				// console.log(res.data);
				let list = res?.data?.data;
				list?.map((item, index) => {
					item.open = false;
				});
				this.list = list;
				this.$nextTick(() => {
					if (this.tabIndex == 0) {
						this.loadingPage = false;
					}
				});
			});
		},
		/* getList2() {
			this.list2[0].info = [];
			this.list2[1].info = [];
			this.$http
				.get(`/platform/periods`, {
					params: {
						'filter[type]': 1, //大卡车
						pageSize: 6
					}
				})
				.then((res) => {
					let list = res?.data?.data;
					this.list2[0].info = this.groupArrayElements(list);
				});
			this.$http
				.get(`/platform/periods`, {
					params: {
						'filter[type]': 2, //小卡车
						pageSize: 6
					}
				})
				.then((res) => {
					let list = res?.data?.data;
					this.list2[1].info = this.groupArrayElements(list);
				});
		}, */
		getList2(key = false, auto = false, async = false) {
			if (async) {
				return new Promise((resolve, reject) => {
					this.$http
						.get(`/platform/periods`, {
							params: {
								'filter[time]': async,
								pageSize: 1,
								current: 1
							}
						})
						.then((res) => {
							if (res?.errcode || res?.data?.errcode) {
								reject(res);
							}
							resolve(res.data.data || []);
						})
						.catch((err) => {
							reject(err);
						});
				});
			} else {
				if (key) {
					this.finished = false;
					this.current = 1;
					this.total = 0;
					this.list = [];
				}
				this.loading = true;
				this.$http
					.get(`/platform/periods`, {
						params: {
							// 'filter[type]': this.$route.query?.type,
							'filter[time]': this.month[this.active]?.label || null,
							// 'filter[keyword]': this.searchData?.keywords || ``,
							pageSize: this.pageSize,
							current: this.current
						}
					})
					.then((res) => {
						let list = res?.data?.data;
						this.current = res?.data?.current;
						this.total = res?.data?.total;
						if (key) {
							this.list2 = list;
						} else {
							this.list2 = this.list2.concat(list);
						}
						this.$nextTick(() => {
							this.loading = false;

							const next = () => {
								if (this.list2?.length >= this.total) {
									this.finished = true;
								}
								this.tips?.clear();
								if (this.tabIndex === 1) {
									this.loadingPage = false;
								}
							};

							if (auto) {
								if (this.list2?.length === 0) {
									this.findPreviousMonthWithContent();
								} else {
									next();
								}
							} else {
								next();
							}
						});
					});
			}
		},
		groupArrayElements(arr) {
			let groupedArray = [];
			for (let i = 0; i < arr.length; i += 2) {
				groupedArray.push(arr.slice(i, i + 2));
			}
			return groupedArray;
		},
		prev() {
			if (!this.$refs.banner) return;
			this.$refs.banner.prev();
		},
		next() {
			if (!this.$refs.banner) return;
			this.$refs.banner.next();
		},
		open(item, index) {
			if (item?.info?.length <= 3) return;
			let list = JSON.parse(JSON.stringify(this.list));
			let dom = list[index];
			dom.open = !dom.open;
			this.$set(this.list, index, dom);
			this.$dataStatistics({ event_type: 'click', page_title: `点一点看展品-${dom.open ? `展开` : `收起`}` }, ``);
		},
		tabChange(key) {
			// console.log(key);
			changeUrl('tabIndex', key);
			let obj = {
				0: `点一点看展品`,
				1: `逛一逛云看展`,
				2: `找圈子获信息`
			};
			this.$dataStatistics({ event_type: 'click', page_title: obj[key] }, ``);

			this.loadingPage = true;
			if (key == 0) {
				this.getList();
			}
			if (key == 1) {
				this.getList2(true, true);
			}
		},
		findPreviousMonthWithContent() {
			if (this.active > 0) {
				this.active--;
				this.getList2(true, true);
			} else {
				this.finished = true;
			}
		},
		monthChange(key, autoLoad = false) {
			this.$dataStatistics({ event_type: 'click', page_title: `往期-${this.month[key]?.label}月` }, ``);
			this.active = key;
			if (autoLoad) this.getList2(true);
		},
		more(item, index) {
			this.$router.push({ path: `/search`, query: { type: index + 1 } });
		},
		new_change(event, item, index) {
			// console.log(event);
			this.list2[index].newCurrent = event;
		},
		play(item, index) {
			// console.log(item);
			if (item?.type == 2) return;
			let data = { id: item?.id, name: item?.name, url: item?.path?.url };
			this.$dataStatistics({ event_type: 'click', page_title: `点击顶部视频` }, `${JSON.stringify(data)}`);
			this.$router.push({ path: `/video`, query: { video: encodeURIComponent(item?.path?.url) } });
		},
		goWeb(item, index) {
			console.log(item);
			if (!item?.pdp_url) return;
			let data = { name: item?.title, id: item?.id };
			this.$dataStatistics({ event_type: 'click', page_title: `往期-跳转` }, `${JSON.stringify(data)}`);
			window.location.href = item?.pdp_url;
		},
		goDetails(child, childIndex, item, index) {
			if (this.clickType) return;
			this.clickType = true;
			let timer = setTimeout(() => {
				clearTimeout(timer);
				this.clickType = false;
			}, 1500);

			let data = {
				id: child?.id,
				name: child?.name,
				father: {
					id: item?.id,
					name: item?.name
				}
			};
			this.$dataStatistics({ event_type: 'click', page_title: `点一点看展品-详情` }, `${JSON.stringify(data)}`);
			this.$router.push({ path: `/details`, query: { id: child.id } });
		},
		videoPlay() {
			this.welcomeKey = false;
			const video = this.$refs.welcome;
			video.play();
		},
		videoEnded() {
			this.welcome = false;
		},
		getLastFourMonths() {
			const launchYear = 2024; // 假定上线年份为2024年
			const launchMonth = 4; // 假定上线月份为3月
			const currentDate = new Date();
			const currentYear = currentDate.getFullYear();
			const currentMonth = currentDate.getMonth() + 1; // 获取当前月份，+1因为JavaScript中月份从0开始
			const maxDisplayMonths = 4; // 最多展示的月份数量

			// 计算从上线月份到当前月份的总月数差，包括跨年的情况
			const totalMonthsSinceLaunch = (currentYear - launchYear) * 12 + currentMonth - launchMonth;

			// 初始化要展示的月份数组
			let monthsToDisplay = [];

			for (let i = totalMonthsSinceLaunch; i >= 0 && i >= totalMonthsSinceLaunch - (maxDisplayMonths - 1); i--) {
				// 计算月份，并考虑跨年的情况
				let month = ((launchMonth - 1 + i) % 12) + 1;
				monthsToDisplay.unshift(month); // 将月份插入数组的开头
			}

			return monthsToDisplay;
		},
		onLoad() {
			if (this.finished) return;
			if (this.list2?.length < this.total) {
				this.current++;
			} else {
				return;
			}
			this.getList2();
		},
		selectOption(item, index) {
			console.log(item, index);
			if (!item?.url) return;
			let data = { name: this.details?.title, id: this.details?.id };
			this.$dataStatistics({ event_type: 'click', page_title: `首页-${item?.name}` }, `${JSON.stringify(data)}`);

			this.$nextTick(() => {
				window.location.href = item?.url;
			});
		},
		goLink() {
			window.location.href = `https://bang.schneider-electric.cn/eleUnv/pc/home`;
		}
	}
};
</script>
<style lang="less" scoped>
.page {
	background: #fafafa;

	.bannerBox {
		width: 828px;
		height: 466px;
		display: block;
		position: relative;
		overflow: hidden;

		& .banner {
			width: 828px;
			height: 466px;
			display: block;

			& .item {
				width: 100%;
				height: 100%;

				&.video {
					position: relative;

					.mask {
						position: absolute;
						left: 0;
						top: 0;
						width: 100%;
						height: 100%;
						z-index: 1;
						display: block;
					}

					.play {
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
						width: 162px;
						height: 162px;
						display: block;
						z-index: 11;
					}

					.cover {
						width: 100%;
						height: 100%;
						display: block;
						overflow: hidden;
					}
				}
			}
		}

		& .option {
			& .icon {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				width: 41px;
				height: 54px;
				display: block;
				z-index: 11;

				&.left {
					left: 20px;
				}

				&.right {
					right: 20px;
				}
			}
		}
	}

	.tab {
		/deep/.van-tabs__line {
			width: calc(100% / 3);
			height: 4px;
			border-radius: 0;
			background-color: @themeColor;
		}

		/deep/.van-tabs__wrap {
			box-shadow: @box-shadow;
		}

		/deep/.van-tab {
			width: calc(100% / 3);
			font-weight: 400;
			font-size: 30px;
			color: #000028;
			line-height: 1;
			transition: all 0.25s;
			position: relative;

			&::after {
				content: '';
				display: block;
				position: absolute;
				right: 0;
				top: 50%;
				z-index: 1;
				transform: translateY(-50%);
				width: 1.5px;
				height: 28px;
				background: #e5e7ec;
			}

			&:last-child {
				&::after {
					display: none;
				}
			}

			span {
				transition: inherit;
			}

			&.van-tab--active {
				font-weight: bold;
				color: @themeColor;
			}
		}

		.main {
			padding: 40px 36px;

			& .list {
				margin-top: 40px;

				& .item {
					box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.06);
					// border-radius: @border-radius;
					border-radius: 30px;
					background-color: #fff;
					overflow: hidden;
					margin-bottom: 30px;
					padding: 30px 28px 32px;
					border-bottom: 1.5px solid #e7e6e6;

					.cover {
						width: 100%;
						height: 286px;
						margin-bottom: calc(30px + ((46px - 30px) / 2 * -1));

						img {
							width: 100%;
							height: 100%;
							display: block;
							object-fit: cover;
						}
					}

					.name {
						font-weight: 400;
						font-size: 30px;
						color: #333333;
						line-height: 46px;
						margin-bottom: calc(24px + ((46px - 30px) / 2 * -1));
					}

					.foot {
						display: flex;
						align-items: center;
						justify-content: space-between;

						.left {
							display: flex;
							align-items: center;
						}

						.time {
							font-weight: 400;
							font-size: 28px;
							color: #626469;
							line-height: 1;
						}

						.address {
							margin-left: 12px;
							font-weight: 400;
							font-size: 28px;
							color: #626469;
							line-height: 1;
						}

						.rightIcon {
							width: 27px;
							height: 20px;
							display: block;
						}
					}
				}
			}
		}

		.content {
			padding: 40px 36px;

			& .list {
				& .item {
					box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.06);
					border-radius: @border-radius;
					background-color: #fff;
					overflow: hidden;
					margin-bottom: 30px;

					.head {
						display: flex;
						align-items: center;
						justify-content: space-between;
						height: 88px;
						padding: 0 30px;
						background-color: @themeColor;
						color: #fff;

						.arrow {
							width: 32px;
							height: 16px;
							display: block;
							transition: all 0.5s;
							transform: rotateX(0deg);
						}

						.more {
							display: flex;
							align-items: center;
							font-size: 28px;

							.moreIcon {
								width: 22px;
								height: 12px;
								display: block;
								transition: all 0.5s;
								transform: rotate(90deg);
							}
						}
					}

					.main {
						padding: 38px 28px;
						// height: 285px;
						height: 330px;
						overflow: hidden;

						.children {
							width: 100%;
							height: 100%;
							margin-bottom: -36px;
							display: block;
							overflow: hidden;
							white-space: pre-wrap;
							word-wrap: break-word;
							word-break: break-all;

							.childrenItem {
								width: calc((100% - 26px * 2) / 3);
								// height: 210px;
								height: 255px;
								display: inline-block;
								margin-right: 26px;
								margin-bottom: 36px;
								overflow: hidden;

								&:nth-child(3n) {
									margin-right: 0;
								}

								.cover {
									width: 216px;
									height: 154px;
									border: 1.5px solid #f2f2f2;
									margin-bottom: 20px;
									overflow: hidden;

									img {
										width: 100%;
										height: 100%;
										display: block;
										object-fit: cover;
										overflow: hidden;
									}
								}

								.name {
									font-weight: 400;
									font-size: 26px;
									color: #333333;
									line-height: 1.5;
								}
							}
						}
					}

					.main_2 {
						.newList {
							.newItem {
								.border {
									padding: 30px 28px 32px;
									height: 50%;
									border-bottom: 1.5px solid #e7e6e6;

									&:last-child {
										padding: 30px 0 32px;
										margin: 0 28px;
									}

									.cover {
										width: 100%;
										height: 286px;
										margin-bottom: calc(30px + ((46px - 30px) / 2 * -1));
										background-color: #000;

										img {
											width: 100%;
											height: 100%;
											display: block;
											object-fit: cover;
										}
									}

									.name {
										font-weight: 400;
										font-size: 30px;
										color: #333333;
										line-height: 46px;
										margin-bottom: calc(24px + ((46px - 30px) / 2 * -1));
									}

									.foot {
										display: flex;
										align-items: center;
										justify-content: space-between;

										.time {
											font-weight: 400;
											font-size: 28px;
											color: #626469;
											line-height: 1;
										}

										.rightIcon {
											width: 27px;
											height: 20px;
											display: block;
										}
									}
								}
							}
						}

						.pagination {
							width: 100%;
							height: 75px;
							display: flex;
							align-items: center;
							justify-content: center;

							span {
								width: 14px;
								height: 14px;
								background: #d7d7d7;
								border-radius: 50%;
								display: block;
								margin: 0 10px;
								transition: all 0.25s;

								&.current {
									background: @themeColor;
								}
							}
						}
					}

					&.open {
						& .arrow {
							transform: rotateX(180deg);
						}

						& .main {
							height: auto !important;
						}
					}
				}
			}
		}

		.info {
			padding: 36px;

			.title {
				padding: 0 2px;
				font-weight: bold;
				font-size: 36px;
				color: #3dcd58;
				line-height: 1;
				margin-bottom: 23px;
			}

			.main {
				border-radius: @border-radius;
				box-shadow: @box-shadow;
				background-color: #fff;
				overflow: hidden;
				margin-bottom: 50px;

				.photo {
					width: 100%;
					overflow: hidden;

					img {
						width: 100%;
						font-size: 0;
						display: block;
					}
				}

				p {
					font-weight: 400;
					font-size: 30px;
					color: #333333;
					line-height: 46px;
					padding: 30px;

					span {
						display: inline-block;
						padding: 10px 20px;
						background-color: @themeColor;
						color: #fff;
						border-radius: 8px;
						margin-left: 20px;
						font-weight: 400;
						font-size: 30px;
						color: #ffffff;
						line-height: 1;
					}

					b {
						margin-top: 20px;
						display: block;
					}
				}
			}
		}
	}

	.emptyDiy,
	/deep/.emptyDiy {
		padding: 0;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.van-empty__description {
			margin-top: 10px;
		}
	}

	.welcome_play {
		width: 120px;
		height: 120px;
		position: fixed;
		z-index: 10000;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		display: block;
	}

	.welcome {
		width: 828px;
		height: 100vh;
		position: fixed;
		z-index: 9999;
		left: 0;
		top: 0;
		display: block;
		background-color: rgba(0, 0, 0, 0.8);
	}

	.closeWelcome {
		position: fixed;
		z-index: 10001;
		right: 20px;
		top: 20px;
		display: block;
		width: 48px;
		height: 48px;
		box-sizing: content-box;
		padding: 10px;
	}
}
</style>
